import React, { useState } from 'react'; // Import useState
import CTABanner from '../components/landingPage/CTABanner';
import SocialMediaCTA from '../components/SocialMediaCTA';
import NewsSection from '../components/landingPage/NewsSection';

const OurCertificatesPage = () => {
  const [selectedImage, setSelectedImage] = useState(null); // State for selected image
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility

  const certificateImages = [
    { src: '/certificates/CIDB_Certificate.png', alt: 'CIDB Certificate' }, // Updated alt text for clarity
    { src: '/certificates/SSM_Certificate.png', alt: 'SSM Certificate' },   // Updated alt text for clarity
  ];

  const openModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  return (
    <div className="min-h-screen pt-40 bg-gray-100 font-poppins py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#364A9A] text-center mb-8 sm:mb-12">
          Our Certificates
        </h1>

        <section className="mb-12 sm:mb-16">
          <div className="flex flex-wrap justify-center gap-6 sm:gap-8">
            {certificateImages.map((cert, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg overflow-hidden group hover:shadow-xl transition-shadow duration-300 w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 cursor-pointer" // Added cursor-pointer
                onClick={() => openModal(cert)} // Added onClick handler
              >
                <img
                  src={cert.src}
                  alt={cert.alt}
                  className="w-full h-[32rem] object-cover"
                />
                <div className="p-4 sm:p-6 text-center"> {/* Added text-center here */}
                  <h3 className="mt-5 sm:mt-6 text-lg sm:text-xl font-bold text-[#364A9A]">{cert.alt}</h3>
                </div>
              </div>
            ))}
          </div>
        </section>

        <CTABanner className="my-12 " />
        <SocialMediaCTA className="my-12 "/>
        <NewsSection  className="my-12 "/>
      </div>

      {/* Full-view Modal */}
      {isModalOpen && selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={closeModal} // Close modal when clicking outside image
        >
          <div className="relative bg-white p-2 rounded-lg max-w-full max-h-full overflow-auto" onClick={(e) => e.stopPropagation()}> {/* Prevent modal close on image click */}
            <button
              className="absolute top-2 right-2 text-gray-800 text-3xl font-bold leading-none hover:text-gray-600"
              onClick={closeModal}
            >
              &times;
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="max-w-full max-h-[90vh] object-contain" // Adjust image size within modal
            />
            {selectedImage.alt && (
              <p className="text-center mt-2 text-gray-700 text-lg">{selectedImage.alt}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default OurCertificatesPage;
